<template>
  <a-tooltip v-if="tooltipText" :title="tooltipText">
    <span>+ {{ omittedValues.length }} ...</span>
  </a-tooltip>
  <span v-else>+ {{ omittedValues.length }} ...</span>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Tooltip as ATooltip } from 'ant-design-vue';
import { getOmittedTagTooltip } from '@/main-page-form/common/queryFormSelectTagUtils';

const props = defineProps<{
  omittedValues: Array<{ label?: unknown; value?: unknown }>;
  resolveLabel?: (value: unknown) => string | undefined;
}>();

const tooltipText = computed(() =>
  getOmittedTagTooltip(props.omittedValues, props.resolveLabel),
);
</script>
